var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_39_81",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 6,
    width: 28,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 6H3C1.89543 6 1 6.85066 1 7.9V23.1C1 24.1493 1.89543 25 3 25H27C28.1046 25 29 24.1493 29 23.1V7.9C29 6.85066 28.1046 6 27 6Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_39_81)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 6H3C1.89543 6 1 6.85066 1 7.9V23.1C1 24.1493 1.89543 25 3 25H27C28.1046 25 29 24.1493 29 23.1V7.9C29 6.85066 28.1046 6 27 6Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_39_81",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 6,
    width: 28,
    height: 19
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 6H3C1.89543 6 1 6.85066 1 7.9V23.1C1 24.1493 1.89543 25 3 25H27C28.1046 25 29 24.1493 29 23.1V7.9C29 6.85066 28.1046 6 27 6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_39_81)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 6H1V7.26666H29V6ZM29 8.53334H1V9.8H29V8.53334ZM1 11.0667H29V12.3333H1V11.0667ZM29 13.6H1V14.8667H29V13.6ZM1 16.1334H29V17.4H1V16.1334ZM29 18.6666H1V19.9334H29V18.6666ZM1 21.2H29V22.4666H1V21.2ZM29 23.7334H1V25H29V23.7334Z",
    fill: "#D02F44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 6H1V14.8667H13V6Z",
    fill: "#46467F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_39_81)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66662 7.89993C3.66662 8.24971 3.36814 8.53327 2.99995 8.53327C2.63176 8.53327 2.33328 8.24971 2.33328 7.89993C2.33328 7.55016 2.63176 7.2666 2.99995 7.2666C3.36814 7.2666 3.66662 7.55016 3.66662 7.89993ZM6.33328 7.89993C6.33328 8.24971 6.03481 8.53327 5.66662 8.53327C5.29843 8.53327 4.99995 8.24971 4.99995 7.89993C4.99995 7.55016 5.29843 7.2666 5.66662 7.2666C6.03481 7.2666 6.33328 7.55016 6.33328 7.89993ZM8.33328 8.53327C8.70147 8.53327 8.99995 8.24971 8.99995 7.89993C8.99995 7.55016 8.70147 7.2666 8.33328 7.2666C7.96509 7.2666 7.66662 7.55016 7.66662 7.89993C7.66662 8.24971 7.96509 8.53327 8.33328 8.53327ZM11.6666 7.89993C11.6666 8.24971 11.3682 8.53327 11 8.53327C10.6318 8.53327 10.3333 8.24971 10.3333 7.89993C10.3333 7.55016 10.6318 7.2666 11 7.2666C11.3682 7.2666 11.6666 7.55016 11.6666 7.89993ZM4.33328 9.79993C4.70147 9.79993 4.99995 9.51638 4.99995 9.1666C4.99995 8.81682 4.70147 8.53327 4.33328 8.53327C3.96509 8.53327 3.66662 8.81682 3.66662 9.1666C3.66662 9.51638 3.96509 9.79993 4.33328 9.79993ZM7.66662 9.1666C7.66662 9.51638 7.36814 9.79993 6.99995 9.79993C6.63176 9.79993 6.33328 9.51638 6.33328 9.1666C6.33328 8.81682 6.63176 8.53327 6.99995 8.53327C7.36814 8.53327 7.66662 8.81682 7.66662 9.1666ZM9.66662 9.79993C10.0348 9.79993 10.3333 9.51638 10.3333 9.1666C10.3333 8.81682 10.0348 8.53327 9.66662 8.53327C9.29843 8.53327 8.99995 8.81682 8.99995 9.1666C8.99995 9.51638 9.29843 9.79993 9.66662 9.79993ZM11.6666 10.4333C11.6666 10.783 11.3682 11.0666 11 11.0666C10.6318 11.0666 10.3333 10.783 10.3333 10.4333C10.3333 10.0835 10.6318 9.79993 11 9.79993C11.3682 9.79993 11.6666 10.0835 11.6666 10.4333ZM8.33328 11.0666C8.70147 11.0666 8.99995 10.783 8.99995 10.4333C8.99995 10.0835 8.70147 9.79993 8.33328 9.79993C7.96509 9.79993 7.66662 10.0835 7.66662 10.4333C7.66662 10.783 7.96509 11.0666 8.33328 11.0666ZM6.33328 10.4333C6.33328 10.783 6.03481 11.0666 5.66662 11.0666C5.29843 11.0666 4.99995 10.783 4.99995 10.4333C4.99995 10.0835 5.29843 9.79993 5.66662 9.79993C6.03481 9.79993 6.33328 10.0835 6.33328 10.4333ZM2.99995 11.0666C3.36814 11.0666 3.66662 10.783 3.66662 10.4333C3.66662 10.0835 3.36814 9.79993 2.99995 9.79993C2.63176 9.79993 2.33328 10.0835 2.33328 10.4333C2.33328 10.783 2.63176 11.0666 2.99995 11.0666ZM4.99995 11.6999C4.99995 12.0497 4.70147 12.3333 4.33328 12.3333C3.96509 12.3333 3.66662 12.0497 3.66662 11.6999C3.66662 11.3501 3.96509 11.0666 4.33328 11.0666C4.70147 11.0666 4.99995 11.3501 4.99995 11.6999ZM6.99995 12.3333C7.36814 12.3333 7.66662 12.0497 7.66662 11.6999C7.66662 11.3501 7.36814 11.0666 6.99995 11.0666C6.63176 11.0666 6.33328 11.3501 6.33328 11.6999C6.33328 12.0497 6.63176 12.3333 6.99995 12.3333ZM10.3333 11.6999C10.3333 12.0497 10.0348 12.3333 9.66662 12.3333C9.29843 12.3333 8.99995 12.0497 8.99995 11.6999C8.99995 11.3501 9.29843 11.0666 9.66662 11.0666C10.0348 11.0666 10.3333 11.3501 10.3333 11.6999ZM11 13.5999C11.3682 13.5999 11.6666 13.3164 11.6666 12.9666C11.6666 12.6168 11.3682 12.3333 11 12.3333C10.6318 12.3333 10.3333 12.6168 10.3333 12.9666C10.3333 13.3164 10.6318 13.5999 11 13.5999ZM8.99995 12.9666C8.99995 13.3164 8.70147 13.5999 8.33328 13.5999C7.96509 13.5999 7.66662 13.3164 7.66662 12.9666C7.66662 12.6168 7.96509 12.3333 8.33328 12.3333C8.70147 12.3333 8.99995 12.6168 8.99995 12.9666ZM5.66662 13.5999C6.03481 13.5999 6.33328 13.3164 6.33328 12.9666C6.33328 12.6168 6.03481 12.3333 5.66662 12.3333C5.29843 12.3333 4.99995 12.6168 4.99995 12.9666C4.99995 13.3164 5.29843 13.5999 5.66662 13.5999ZM3.66662 12.9666C3.66662 13.3164 3.36814 13.5999 2.99995 13.5999C2.63176 13.5999 2.33328 13.3164 2.33328 12.9666C2.33328 12.6168 2.63176 12.3333 2.99995 12.3333C3.36814 12.3333 3.66662 12.6168 3.66662 12.9666Z",
    fill: "url(#paint0_linear_39_81)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_39_81",
    x: 2.33328,
    y: 7.2666,
    width: 9.33328,
    height: 34.9044,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 28.5714
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_39_81"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_39_81",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39_81",
    x1: 2.33328,
    y1: 7.2666,
    x2: 2.33328,
    y2: 13.5999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa);
export default __webpack_public_path__ + "static/media/USA.44e883493b1f3d3ccab88a3f423b226a.svg";
export { ForwardRef as ReactComponent };